import { HttpClient } from '@angular/common/http';
import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { Observable, forkJoin, tap } from 'rxjs';
import { Language, LanguageCode, LanguageStore } from './language.store';
export enum AvailableLanguage {
  FRENCH = 'fr',
  ENGLISH = 'en'
}
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  #httpClient = inject(HttpClient);
  #languageStore = inject(LanguageStore);
  #API_URL = `/i18n`;
  readonly #supportedLanguages: LanguageCode[] = [
    AvailableLanguage.FRENCH,
    AvailableLanguage.ENGLISH
  ];
  public static STORAGE_KEY: string = 'language';
  public $userLanguage: WritableSignal<LanguageCode> = signal(
    localStorage.getItem(LanguageService.STORAGE_KEY) as LanguageCode
  );

  public get(languageKey: LanguageCode): Observable<Language> {
    return this.#httpClient.get<Language>(
      `${this.#API_URL}/${languageKey}.json`
    );
  }

  public initialiseLanguages(): Observable<[Language, Language]> {
    return forkJoin([
      this.get(AvailableLanguage.FRENCH),
      this.get(AvailableLanguage.ENGLISH)
    ]).pipe(
      tap(([fr, en]) => {
        this.#languageStore.addLanguageDictionary(fr, 'fr');
        this.#languageStore.addLanguageDictionary(en, 'en');
        this.initialiseLanguage();
      })
    );
  }
  /**
   * Initialise le language par defaut
   * Si il ya deja une valeur dans le local storage inititalise avec cette valeur
   * Sinon initialise avec le language du navigateur
   * Si le language n'est pas supporte le met en Francais
   */
  private initialiseLanguage(): void {
    let userLanguage: LanguageCode | null = localStorage.getItem(
      LanguageService.STORAGE_KEY
    ) as LanguageCode;
    if (!userLanguage) {
      let navigatorLanguage: LanguageCode = navigator.language.split(
        '-'
      )[0] as LanguageCode;
      if (!this.#supportedLanguages.includes(navigatorLanguage)) {
        navigatorLanguage = AvailableLanguage.ENGLISH;
      }
      userLanguage = navigatorLanguage;
      this.$userLanguage.set(userLanguage);
    }
    this.#languageStore.setCurrentLanguageCode(userLanguage);
  }
}
